__turbopack_context__.v({
  "carousel": "iQrGzW_carousel",
  "container": "iQrGzW_container",
  "scrollButton": "iQrGzW_scrollButton",
  "scrollButtonGrayLeft": "iQrGzW_scrollButtonGrayLeft",
  "scrollButtonGrayRight": "iQrGzW_scrollButtonGrayRight",
  "scrollButtonIcon": "iQrGzW_scrollButtonIcon",
  "scrollButtonWhiteLeft": "iQrGzW_scrollButtonWhiteLeft",
  "scrollButtonWhiteRight": "iQrGzW_scrollButtonWhiteRight",
});
